<template>
  <div ref="target" class="news-list">
    <div class="left">
      <div class="top">
        <div class="top-carousel">
          <NewsCarousel :bannerList="bannerList" />
          <SubmainList :domainList="domainList" />
        </div>
      </div>
      <div class="bottom">
        <NewsVideo :list="list" />
      </div>
    </div>
    <div class="middle">
      <PolicyNews :policyList="policyList" :domainList="domainList" />
    </div>
    <div class="right">
      <NoticeNews :noticeList="noticeList" :domainList="domainList" />
      <div class="notes">
        <NewsTests :testList="testList" />
      </div>
    </div>
  </div>
</template>

<script>
import NewsVideo from "../newsvideo/news-video";
import NewsTests from "../newstests/news-tests.vue";
import NewsCarousel from "../common/new-carousel.vue";
import PolicyNews from "../common/policy-news.vue";
import SubmainList from "../common/submain-list.vue";
import NoticeNews from "../common/notice-news.vue";
import {
  findHuShiNews,
  findNewsVideo,
  findNewsTests,
  findNewsBanner,
} from "@/api/news";
import {
  useLazyData,
  useLazyNewsTests,
  useLazyNews,
  useLazyNewsBanner,
} from "@/hooks/index";
import { ref, computed } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    NewsVideo,
    NewsTests,
    NewsCarousel,
    PolicyNews,
    NoticeNews,
    SubmainList,
  },
  setup() {
    const clID = ref(1951);
    const target = ref(null);
    const store = useStore();
    //const policyList = ref([]);
    //const noticeList = ref([]);
    const { result } = useLazyData(target, () =>
      findNewsVideo({ clID: [clID.value] })
    );
    const { testList } = useLazyNewsTests(target, () =>
      findNewsTests({ clID: [clID.value] })
    );
    //数据懒加载
    const { notice, policy } = useLazyNews(target, () =>
      findHuShiNews({ chID: 206, coID: 154 })
    );
    //news页面中banner懒加载

    const { bannerList } = useLazyNewsBanner(target, () => {
      findNewsBanner({ chID: 206, coID: 154 });
    });
    const domainList = computed(() => {
      let list = store.state.category.list.find(
        (items) => items.clID === clID.value
      );
      return list;
    });
    return {
      policyList: policy,
      noticeList: notice,
      domainList,
      list: result,
      testList,
      target,
      NewsVideo,
      bannerList,
    };
  },
};
</script>

<style lang="less" scoped>
.news-list {
  height: 500px;
  //background: #f0e5e5;
  display: flex;
  justify-content: space-between;
  .left {
    width: 400px;
    height: 500px;
    display: flex;
    flex-direction: column;
    .top {
      width: 400px;
      height: 240px;
      .top-carousel {
        display: inline-block;
        width: 360px;
        height: 130px;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 15px;
        border-radius: 5px;
      }
    }

    .bottom {
      width: 400px;
      height: 250px;
    }
  }
  .middle {
    margin-top: 15px;
    width: 400px;
    overflow: hidden;
    border: 1px solid rgb(244, 244, 244);
    .policy {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      background: rgb(244, 244, 244);
      div {
        display: flex;
        align-items: center;
        i {
          display: inline-block;
          width: 3px;
          height: 20px;
          background: @shColor;
        }
        h3 {
          margin-left: 10px;
        }
      }
      a {
        display: flex;
        align-items: center;
        color: #999;
        &:hover {
          color: @shColor;
        }
      }
    }
    .policy-news {
      ul {
        width: 400px;
        margin-top: 5px;
        padding: 5px 5px 5px 5px;
        & :hover {
          color: @shColor;
          cursor: pointer;
        }
        a {
          display: inline-block;
          width: 400px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          padding-right: 10px;
        }
      }
    }
  }
  .right {
    margin-top: 15px;
    width: 400px;

    .notes {
    }
  }
}
</style>
